<template>
    <div>
        <pxkeji-rightHeader />
        <div class="mainWrapper clearfix">
            <div class="articleMeauleft" :style="height">
                <a-divider orientation="left">新闻分类</a-divider>
                <a-tree checkable :replaceFields="replaceFields" :treeData="treeDataCategory" @select="this.onSelect"
                    @check="this.onCheck" />
            </div>
            <div class="articleMainRight">
                <div class="pxkeji-right-box">
                    <a-form class="ant-advanced-search-form">
                        <a-row :gutter="24">
                            <a-col :span="8">
                                <a-form-item label="标题">
                                    <a-input placeholder="请输入" v-model="where.keyword.title" />
                                </a-form-item>
                            </a-col>
                            <a-col :span="8">
                                <a-form-item label="创建人">
                                    <a-input placeholder="请输入" v-model="where.keyword.name" />
                                </a-form-item>
                            </a-col>
                            <a-col :span="6" :style="{ textAlign: 'left' }">
                                <a-button type="primary" @click="searchList">搜索</a-button>
                            </a-col>
                        </a-row>
                    </a-form>
                </div>
                <div class="pxkeji-right-box">
                    <a-table :columns="list.columns" rowKey="id" :pagination="list.pagination" @change="onChange"
                        :dataSource="list.datas" :loading="isloading"
                        :rowSelection="{ type: 'checkbox', onChange: onRowChange, selectedRowKeys: selectRows }"
                        :locale="{ emptyText: '暂无数据' }">
                    </a-table>
                    <a-button type="primary" :style="{ margin: '10px' }" @click="clickSaveBut">选择并授权</a-button>
                </div>
            </div>
            <a-modal v-model="subsite.visible" title="选择要更新的站点" width="80%" :footer="false">
                <DataZone @confirm="confirmChoose"></DataZone>
            </a-modal>
        </div>

    </div>
</template>
<script>
import DataZone from "./dataZone.vue";//选择站点
const columns = [
    {
        dataIndex: "articlecategoryName",
        key: "articlecategoryName",
        align: "center",
        title: "分类名称"
    },
    {
        dataIndex: "title",
        key: "title",
        align: "center",
        title: "标题"
    },
    {
        dataIndex: "addtime",
        key: "addtime",
        align: "center",
        title: "添加时间"
    },
];


var that;
export default {
    props: {
        id: String,
        adminTel: String
    },
    name: "subjectChoose",
    data() {
        return {
            // treeData: [],
            expand: false, //高级搜索
            height: {
                height: ""
            },
            treeDataCategory: [],
            replaceFields: { children: "list", title: "name", key: "id" },
            list: {
                columns, //表头
                datas: [], //数据
                pagination: {
                    //分页器
                    showQuickJumper: true,
                    hideOnSinglePage: true,
                    total: 0,
                    showTotal: function (total, range) {
                        return "共 " + total + " 条";
                    },
                    current: 1, //页码
                    defaultPageSize: 10 //页容
                }
            },
            subsite: {
                visible: false,
                ids:this.id
            },
            where: {
                //查询条件
                keyword: {
                    //搜索条件
                    name: "",
                    title: "",
                    categoryId: []
                }
            },
            articleTypeIds: "",
            allSelectRows: [],
            usedArticleTypeIds: [],
            selectRows: [], //选中项编号
            isloading: false,
            info: {
                title: "",
                visible: false,
                id: 0,
                parentid: 0
            }
        };
    },
    components: {
        DataZone: DataZone
    },
    mounted: function () {
        this.$nextTick(function () {
            that = this;
            this.getUsedCategoryIds();
            this.GetList();
            this.getTree();
        });
    },
    watch: {
        selectRows: function () {
            //console.log("watch", val);
        }
    },
    methods: {
        onRowChange(selectedRowKeys) {
            this.selectRows = selectedRowKeys;
            for (var i in that.list.datas) {
                if (selectedRowKeys.indexOf(that.list.datas[i].id) != -1) {
                    //选中
                    var find = false;
                    for (var sel in that.allSelectRows) {
                        if (that.allSelectRows[sel] == that.list.datas[i].id) {
                            find = true;
                            break;
                        }
                    }

                    if (!find) {
                        that.allSelectRows.push(that.list.datas[i].id);
                    }
                } else {
                    for (var sel in that.allSelectRows) {
                        if (that.allSelectRows[sel] == that.list.datas[i].id) {
                            that.allSelectRows.splice(sel, 1);
                            break;
                        }
                    }
                }
            }
        },
        //树形

        onCheck(selectedKeys, info) {
            this.articleTypeIds = selectedKeys.join(",");
        },
        onSelect(selectedKeys, info) {
            that.where.keyword.categoryId = selectedKeys[0];
            this.GetList();
        },
        GetList() {
            //获取列表
            this.isloading = true;
            this.$api.article
                .getPageListNotIncludeOldData(
                    this.list.pagination.current,
                    this.list.pagination.defaultPageSize,
                    this.where.keyword.title,
                    this.where.keyword.categoryId,
                    this.id
                )
                .then(res => {
                    this.isloading = false;
                    if (res.errorCode == this.$msg.responseCode.success) {
                        this.list.datas = res.data.records;
                        this.list.pagination.total = Number(res.data.total);
                        res.data.records.forEach(function (item, index) {
                            if (item.optionConf) {
                                var opArr = [];
                                for (let i in JSON.parse(item.optionConf)) {
                                    opArr.push(i + ":" + JSON.parse(item.optionConf)[i]);
                                }
                                item.optionConf = opArr.join(" ");
                            }
                        });
                    } else {
                        this.$message.error(res.errorMsg);
                    }
                })
                .catch(() => {
                    this.isloading = false;
                });
        },
        treeChange(val) {
            this.where.keyword.categoryId = val;
        },
        checkData(typelist, item) {
            for (let i in item) {
                if (typelist.indexOf(item[i].id) > -1) {
                    item[i].disableCheckbox = true;
                    if (item[i].list && item[i].list.length > 0) {
                        this.checkData(typelist, item[i].list)
                    }
                }

            }
        },
        getTree() {
            this.$api.cms.articlecategory
                .getTree()
                .then(res => {
                    if (res.errorCode == this.$msg.responseCode.success) {
                        // res.data.forEach(function(item, index) {
                        //    if(item.)
                        // });
                        var data = res.data;
                        if (this.usedArticleTypeIds.length > 0) {
                            this.checkData(this.usedArticleTypeIds.join(","), data)
                        }
                        this.treeDataCategory = data;
                    } else {
                        this.error(res.errorMsg);
                    }
                })
                .catch(() => {
                    this.isloading = false;
                });
        },
        getUsedCategoryIds() {
            this.$api.cms.articlecategory
                .getUsedArticleTypeIds(this.id)
                .then(res => {
                    if (res.errorCode == this.$msg.responseCode.success) {
                        this.usedArticleTypeIds = res.data

                    } else {
                        this.error(res.errorMsg);
                    }
                })
                .catch(() => {
                    this.isloading = false;
                });
        },
        onChange(page) {
            //页面切换回调
            this.list.pagination.current = page.current;
            this.GetList();
        },
        searchList() {
            this.list.pagination.current = 1;
            this.GetList();
        },
        clear() {
            //清空搜索条件
            for (var info in this.where.keyword) {
                this.where.keyword[info] = "";
            }
        },

        clickSaveBut(){
            this.subsite.visible=true;
        },

        confirmChoose(e){
            this.subsite.visible=false;
            this.subsite.ids = e.dataZones.join(",");
            this.save();
        },

        //选择并返回
        save() {
            this.isloading = true;
            if (this.allSelectRows.length == 0 && this.articleTypeIds == "") {
                this.$message.error("请选择分类或者新闻");
                return;
            }
            this.$api.area
                .initData(this.subsite.ids, "news", this.articleTypeIds, this.allSelectRows.join(","), this.adminTel)
                .then((res) => {
                    this.isloading = false;
                    if (res.errorCode == this.$msg.responseCode.success) {
                        this.$message.success(res.errorMsg);
                        this.$emit("callbackMethod")
                    } else {
                        this.$message.error(res.errorMsg);
                    }
                })
                .catch(() => {
                    this.isloading = false;
                });
        }
    }
};
</script>

<style>
.ant-advanced-search-form .ant-form-item {
    display: flex;
}

.ant-advanced-search-form .ant-form-item-control-wrapper {
    flex: 1;
}

#components-form-demo-advanced-search .ant-form {
    max-width: none;
}

#components-form-demo-advanced-search .search-result-list {
    margin-top: 16px;
    border: 1px dashed #e9e9e9;
    border-radius: 6px;
    background-color: #fafafa;
    min-height: 200px;
    text-align: center;
    padding-top: 80px;
}

.cang_sta {
    text-align: center;
}

.cang_sta img {
    width: 35px;
}

.mainWrapper {
    box-sizing: border-box !important;
}

.articleMeauleft {
    width: 20%;
    padding: 0 1%;
    min-height: 700px;
    background: #fff;
    float: left;
    margin-top: 10px;
}

.articleMainRight {
    width: 80%;
    float: right;
}
</style>

